import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Documentação</Title>

                    <section className="mt-2 p-3">

                        <p>
                            Axial, sagital e coronal C/C utilizar ww 150 e wl 45;
                        </p>
                        <p>
                            <b>Axial P.M. C/C -</b> 1 filme na formatação de 20 imagens;<br/>
                            <b>Sagital P.M. C/C -</b> 1 filme na formatação de 12 imagens;<br/>
                            <b>Coronal P.M. C/C -</b> 1 filme na formatação de 12 imagens;<br/>
                        </p>

                        <p>
                            <b>Impressão Mista, Filme e Papel</b><br/>
                            Axial em papel; <br/>
                            Coronal em filme;<br/>
                            Sagital em papel;<br/>
                        </p>
                        <p>
                            <b>Impressão apenas em Papel</b><br/>
                            Axial em papel;<br/>
                            Coronal em papel;<br/>
                            Sagital em papel;<br/>
                        </p>
                    </section>
                </div>
            </div>
        </Container>
    )
}